<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body text-center">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="my-0 font-bold mb-2"
          v-text="'Add to Member Groups?'"
        />
      </header>

      <div>
        <div class="flex justify-center items-baseline mt-4">
          <div class="input-group  w-2/3">
            <input
              v-model="search"
              placeholder="Search"
              type="text"
            >
          </div>
          <div class="text-xs pl-4 w-1/3">
            <a
              href="#"
              @click.prevent="selectAllGroups"
              v-text="'Select All'"
            />
            |
            <a
              href="#"
              @click.prevent="selectNoGroups"
              v-text="'Select None'"
            />
          </div>
        </div>
        <ul class="scroll-checklist scroll-blue">
          <li
            v-for="membershipGroup in membershipGroups"
            :key="membershipGroup.uuid"
          >
            <input
              :id="`act-as-group-${membershipGroup.uuid}`"
              v-model="selectedGroups"
              :value="membershipGroup.uuid"
              type="checkbox"
              :name="`act-as-group-${membershipGroup.uuid}`"
            >
            <label
              :for="`act-as-group-${membershipGroup.uuid}`"
              class="checkbox"
              v-text="membershipGroup.attributes.title"
            />
          </li>
        </ul>
        <footer class="text-center">
          <a
            class="btn btn--sm mb-2"
            href="#"
            @click.prevent="actAsMember"
            v-text="actAsMemberText"
          />
        </footer>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {debounce} from 'lodash'

export default {
  name: 'ActAsMembershipGroupsModal',
  data() {
    return {
      search: '',
      selectedGroups: [],
    }
  },

  computed: {
    ...mapState({
      membershipGroups: state => state.membership.membershipGroups.data,
      show: state => state.union.actAsMembershipGroupsModal.open,
      roleId: state => state.union.actAsMembershipGroupsModal.roleId,
    }),
    actAsMemberText() {
      return this.selectedGroups.length === 1
        ? 'Act as member part of 1 group'
        : `Act as member part of ${this.selectedGroups.length} groups`
    },
  },

  watch: {

    show() {
      if (this.show) {
        if (!this.membershipGroups.length) {
          this.fetchMembershipGroups()
        }
      }
    },

    search: debounce(function () {
      this.fetchMembershipGroups({
        params: {
          query: this.search,
        },
      })
    }, 500),
  },

  methods: {
    ...mapActions({
      fetchMembershipGroups: 'membershipGetMembershipGroups',
    }),

    actAsMember() {
      window.location.replace(this.$urlGenerator.active(`act-as/${this.roleId}?${this.selectedGroups.map(groupId => `groupsIds[]=${groupId}`).join('&')}`))
    },

    selectAllGroups() {
      this.selectedGroups = _.map(this.membershipGroups, 'uuid')
    },

    selectNoGroups() {
      this.selectedGroups = []
    },

    close() {
      this.$store.commit('closeActAsMembershipGroupsModal')

      // Delay to allow animation to complete before resetting.
      const vm = this

      setTimeout(function () {
        vm.search = ''
        vm.selectedGroups = []
      }, 2000)
    },
  },
}
</script>
